export const parseFieldValue = (fieldType, draft) => {
	if (fieldType === 'number') return draft !== '' ? Number(draft) : null;
	if (fieldType === 'checkbox') return draft;
	return draft || null;
};

/**
 * Builds the API patch for an entity's built-in (default) fields from a form draft.
 *
 * @param {Array<{isDefault: boolean, fieldKey: string, fieldType: string}>} fieldDefs
 * @param {Object} draft - Form values keyed by fieldKey (strings as typed)
 * @param {Object} [original] - Persisted entity; when given, only changed fields are included
 * @returns {Object} Parsed values keyed by fieldKey
 */
export function buildDefaultFieldPatch(fieldDefs, draft, original) {
	const patch = {};
	for (const def of fieldDefs) {
		if (!def.isDefault) continue;
		const value = parseFieldValue(def.fieldType, draft[def.fieldKey] ?? '');
		if (!original || value !== (original[def.fieldKey] ?? null)) patch[def.fieldKey] = value;
	}
	return patch;
}
